/**
 * CartNotification
 */
class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('[data-header]');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.activeClass = 'cart-notification-is-open';

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  /**
   * open
   */
  open(hasError = false) {
    const errorClass = 'cart-notification--has-error';
    const successClass = 'cart-notification--has-no-error';
    if (hasError) {
      document.querySelector('body').classList.add(errorClass);
      document.querySelector('body').classList.remove(successClass);
    } else {
      document.querySelector('body').classList.remove(errorClass);
      document.querySelector('body').classList.add(successClass);
    }

    document.body.classList.add(this.activeClass);
    this.notification.classList.add('animate', 'active');
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });
    document.body.addEventListener('click', this.onBodyClick);
  }

  /**
   * close
   */
  close() {
    document.body.classList.remove(this.activeClass);
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  /**
   * renderContents
   * @param {Object} parsedState
   */
  renderContents(parsedState) {
    this.productId = parsedState.items[0].id;
    this.notification = document.getElementById('cart-notification');

    this.getSectionsToRender().forEach((section => {
      // check if the section has content and show the container if it doesn't
      if (this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)) {
        document.getElementById(section.id).classList.remove('visually-hidden');
        this.notification.classList.remove('smaller');
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);

        // add event listeners for the new elements created
        this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
          closeButton.addEventListener('click', this.close.bind(this))
        );
      }
      // check if the section has content and hide the container if it doesn't
      else {
        document.getElementById(section.id).classList.add('visually-hidden');
        this.notification.classList.add('smaller');
      }
    }));

    this.open();
  }

  /**
   * renderQuantityError
   * @param {String} productName
   */
  renderQuantityError(productName) {

    const errorMessageElem = this.notification.querySelector('[data-cart-notification-error-message]');

    errorMessageElem.innerText = window.cartStrings.quantityError.replace('[product_name]', productName);

    this.open(true);
  }

  /**
   * getSectionsToRender
   * @returns {Array} Sections to render
   */
  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-header',
        selector: `#cart-notification-header-${this.productId}`,
      },
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-product-recommendations',
        selector: `#cart-notification-product-${this.productId}-recommendations`,
      },
    ];
  }

  /**
   * getSectionInnerHTML
   * @param {String} String that contains html
   * @param {String} selector
   * @returns
   */
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  /**
   * handleBodyClick
   * @param {Object} evt
   */
  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      this.close();
    }
  }

  /**
   * setActiveElement
   * @param {Node} element
   */
  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}
